import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleRenderer from '@/components/feature/ArticleRenderer';
import { basetaoShoppingGuide } from '@/mocks/basetao-shopping-guide';

export default function BasetaoShoppingGuidePage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <ArticleRenderer content={basetaoShoppingGuide} breadcrumbLabel="Basetao Shopping Guide" headerImage="https://readdy.ai/api/search-image?query=Elegant%20shopping%20guide%20concept%20with%20open%20book%20and%20fashion%20accessories%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cream%20and%20terracotta%20warm%20tones%2C%20editorial%20lifestyle%20photography%2C%20clean%20minimalist%20composition%2C%20gentle%20shadows&width=1200&height=400&seq=btsg-header-2026&orientation=landscape" articleSlug="/article/basetao-shopping-guide" />
      <section className="py-12 md:py-16 bg-background-100 border-t border-background-200/60">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">Start Your Basetao Journey Today</h3>
          <p className="text-foreground-600 text-sm md:text-base mb-6">Ready to shop smarter? Apply what you have learned and start exploring Basetao.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-semibold rounded-md hover:bg-primary-600 transition-all text-sm whitespace-nowrap">Visit Basetao Spreadsheet</a>
            <Link to="/" className="w-full sm:w-auto px-8 py-3 bg-foreground-900 text-white font-semibold rounded-md hover:bg-foreground-800 transition-all text-sm whitespace-nowrap">Back to Home</Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}